export const moduleRoutes: Record<string, string> = {
  "/dashboard": "DASHBOARD",
  "/admin": "ADMIN",
  "/user": "USER",
  "/order": "ORDER",
  "/blog": "BLOG",
  "/cms": "CMS",
  "/coupons": "COUPON",
  "/group": "GROUP",
  "/institute": "INSTITUTE",
  "/module": "MODULE",
  "/file-manager": "FILE_MANAGER",
  "/batch-type": "BATCH_TYPE",
  "/products": "PRODUCT",
  "/product/excel-logs": "PRODUCT",
  // "/franchise": "FRANCHISE",
  // "/advance-payment": "ADVANCE_PAYMENT",
  "/payment": "PAYMENT",
  "/transaction": "TRANSACTION",
  // "/drawer": "DRAWER",
  // "/dues":"DUES",
  // "/payment-mode": "PAYMENT_MODE",
  "/user-role": "USER_ROLE",
  "/course": "COURSE",
  "/student": "STUDENT",
  // "/book": "BOOK",
  "/category": "CATEGORY",
  "/syllabus": "SYLLABUS",
  "/level": "LEVEL",
  "/subject": "SUBJECT",
  "/faculty": "FACULTY",
  "/mode": "MODE",
  // "/course-type": "COURSE_TYPE",
  // "/attempt": "ATTEMPT",
};
